export const de = {
    navigation: {
        profile: "Profil",
        agencies: "Agenturen",
        logout: "Logout",
        settings: "Einstellungen",
    },
    admin: {
        globalBranding: "Globales Branding",
        settings: "Einstellungen",
    },
    settings: {
        clearAgencies: "Agenturen bereinigen",
        templates: "Vorlagen",
        team: "Team",
        agencies: "Agenturen",
        suppliers: "Unternehmer",
        options: "Optionen",
        taxes: "Steuern",
    },
    auth: {
        email: "E-Mail",
        password: "Passwort",
        passwordRepeat: "Passwort wiederholen",
        passwordSet: "Passwort speichern",
        remember: "eingeloggt bleiben",
        forgot: "Passwort vergessen?",
        login: "Anmelden",
        classicLogin: "Mit E-Mail und Passwort anmelden",
        magicLinkLogin: "Mit Magic Link anmelden",
        requestLink: "Anmeldelink anfordern",
        pwUpdated: "Passwort wurde erfolgreich gesetzt",
        forgotText:
            "Teilen Sie uns Ihre E-Mail-Adresse mit und wir senden Ihnen einen Link zum Zurücksetzen des Passworts zu.",
        invalidInvite:
            "Diese Einladung wurde bereits erfolgreich angenommen. Klicken Sie auf den Button um sich einzuloggen. Falls Sie ihr Passwort vergessen haben können sie es einfach wieder zurücksetzen.",
        contactConsultant: "Bitte kontaktieren Sie Ihren Berater.",
        forgotPassword: "Passwort vergessen",
        invalidToken: "Ungültiges Token",
        contactSupport: "Bitte Support kontaktieren.",
        setPassword: "Passwort setzen",
        agencyInviteIntro:
            "Hallo {user}, bitte setzen Sie noch Ihr Passwort – dann kann es auch schon losgehen.",
        agencyInviteIntroNoPassword:
            "Hallo {user} einfach auf den Button klicken und der Agentur beitreten",
        agencyInviteTitle: "{agency} beitreten",
        apartmentInviteTitle: "{project} beitreten",
        apartmentInviteIntro:
            "Hallo {user}, bitte setzen Sie noch Ihr Passwort – dann kann es auch schon losgehen.",
        apartmentInviteIntroNoPassword:
            "Hallo {user} einfach auf den Button klicken um dir das Projekt anzuschauen",
        projectJoined: "Projekt beigetreten",
        confirmAuthCode:
            "Bitte bestätigen Sie den Zugriff auf Ihr Konto, indem Sie den von Ihrer Authentifizierungsanwendung bereitgestellten Authentifizierungscode eingeben.",
        confirmAuthRecoveryCode:
            "Bitte bestätigen Sie den Zugang zu Ihrem Konto, indem Sie einen Ihrer Notfallcodes eingeben.",
        useRecoveryCode: "Einen Wiederherstellungscode verwenden",
        useAnAuthCode: "Einen Authentifizierungscode verwenden",
        resetPassword: "Passwort zurücksetzen",
        setPasswordDesc: "Bitte legen Sie ihr Passwort fest.",
        confirmPassword: "Passwort bestätigen",
        resetPasswordDesc:
            "Bestätigen Sie bitte Ihr Passwort um die 2-Faktor Authentifizierung zu aktivieren.",
        noPasswordSet: "Noch kein Passwort festgelegt",
        noPasswordSetDesc:
            "Sie haben für dieses Konto noch kein Passwort festgelegt. Die Anmeldung ist deshalb ausschliesslich per Magic-Link möglich. Um dies zu ändern können Sie hier ein Passwort festlegen.",
        linkSent: "Ihr Link wurde versendet",
        agencyJoined: "Erfolgreich beigetreten",
        acceptInvite: "Einladung annehmen",
        secureArea: "Sicherheitsbereich",
        secureAreaDescription:
            "Dies ist ein gesicherter Bereich der Applikation. Bitte bestätigen Sie Ihr Passwort, um fortzufahren.",
    },
    projects: {
        // Auftrag Luca, 2026-08-20 (Spec
        // docs/superpowers/specs/2026-08-20-berechnungsmodus-auf-projektebene-design.md):
        // der Berechnungsmodus haengt seit diesem Auftrag am PROJEKT. Die
        // Texte sind bewusst eigene Schluessel und keine Verweise auf den
        // `agencies`-Block: dort steht die VOREINSTELLUNG, hier die
        // verbindliche Wahl fuer dieses eine Mandat.
        // Zwei Schluessel, weil derselbe Text an zwei Stellen anders gesetzt
        // wird (Fix-Runde nach dem ui-validator, K2): die Kopfzeile der
        // Projektseite braucht den Doppelpunkt, das Formular-Etikett nicht —
        // dort haben alle Nachbaretiketten keinen.
        feeCalculationMode: "Berechnung von Gebühr und Honorar:",
        feeCalculationModeLabel: "Berechnung von Gebühr und Honorar",
        feeCalculationModeExceptionHint: "Nur in Ausnahmefällen.",
        feeCalculationModeDefaultBadge: "Standard",
        feeCalculationModes: {
            offer_based: "Offertenbasiert",
            budget_based: "Budgetbasiert",
        },
        feeCalculationModeHints: {
            offer_based:
                "Grundlage ist die Netto-Summe der angehakten Offerten der verrechneten Bestellungsänderungen. Das Budget spielt in der Rechnung keine Rolle.",
            budget_based:
                "Grundlage sind die Mehrkosten (Kosten abzüglich Budget, netto). Die Häkchen «Gebühr berechnen» und «Honorar berechnen» je Offerte entfallen.",
        },
        feeCalculationModeFinal:
            "Diese Wahl gilt für das ganze Projekt und lässt sich nach dem Anlegen nicht mehr ändern — sie bestimmt rückwirkend jede Abrechnung. Eine spätere Korrektur ist nur über den Support möglich.",
        feeCalculationModeCorrect: "Berechnungsart korrigieren",
        feeCalculationModeCorrectTitle: "Berechnungsart dieses Projekts korrigieren?",
        feeCalculationModeCorrectText:
            "Sämtliche Abrechnungen dieses Projekts werden ab sofort neu gerechnet — auch abgeschlossene Wohnungen und bereits versandte Exporte. Erfasste Budgets und die Häkchen je Offerte bleiben gespeichert. Im budgetbasierten Modus ist die Spalte «Budget» nicht ausblendbar: ein für Käufer ausgeblendetes Budget wird dort wieder sichtbar. Die Korrektur wird protokolliert.",
        feeCalculationModeUpdated: "Berechnungsart wurde korrigiert",
        project: "Projekt",
        projects: "Projekte",
        messages: "Nachrichten",
        myProjects: "meine Projekte",
        inactiveProjects: "inaktive Projekte",
        projectDetail: "Projekt Detail",
        projectNumber: "Projektnummer",
        projectDescription: "Allgemeine Projektinformationen",
        newProject: "Neues Projekt",
        name: "Name",
        number: "Projektnummer",
        street: "Strasse",
        zip: "PLZ",
        city: "Ort",
        country: "Land",
        image: "Projektbild",
        imageDescription: "Foto zum Projekt",
        chooseImage: "Bild wählen",
        removeImage: "Bild entfernen",
        editImage: "Bild bearbeiten",
        lead: "Projektleitung",
        leadDescription: "Kontaktdaten zur Projektleitung",
        settings: "Einstellungen",
        presets: "Voreinstellungen",
        contact: "Kontakt",
        editContact: "Kontakt bearbeiten",
        card: "Karte anzeigen",
        deadline: "Deadline",
        apartments: "Wohnungen",
        newApartment: "Neue Wohnung",
        editBase: "Projekt editieren",
        projectLead: "Projektleitung",
        projectAssistance: "Projektbetreuung",
        state: "Status",
        stateChange: "Status ändern",
        leadChange: "Projektleitung ändern",
        imageChange: "Projektbild ändern",
        projectStateDescription:
            "Der Projektstatus wirkt sich auf die Sichtbarkeit dieses Projektes aus.",
        projectStateChange: "Projektstatus ändern",
        deleteProject: "Projekt löschen",
        editAssistance: "Projektbetreuung ändern",
        userId: "Benutzer-ID",
        persons: "Personen",
        personsDescription: "Mitarbeiter aus Ihrem Team",
        created: "Projekt erstellt",
        updated: "Projekt aktualisiert",
        deleted: "Projekt erfolgreich gelöscht",
        template: "Vorlage",
        templatePresets: "Projekt Vorlage",
        templateDescription:
            "Bitte wählen Sie eine Vorlage, welche auf dieses Projekt angewendet werden soll.",
        selectTemplate: "Vorlage auswählen",
        settingsDescription: "Projektweit gültige Parameter",
        consultancyFee: "Honorar",
        baseFee: "Gebühr",
        uploadImage: "Ein Bild hochladen",
        imageRemoved: "Bild entfernt",
        fileInfo: "JPG / PNG (max. {size} MB)",
        fileTooBig: "Die Datei ist zu gross!",
    },
    apartments: {
        projectNameHeader: "Projekt",
        apartmentSelector: "Wohnung",
        apartment: "Wohnung",
        overview: "Übersicht",
        newApartment: "Neue Wohnung erstellen",
        apartmentDescription: "Informationen zur Wohnung",
        number: "Wohnungsnummer",
        rooms: "Zimmer",
        roomsAmount: "Anzahl Zimmer",
        area: "Nettowohnfläche",
        finishedTopics: "Themen abgeschlossen",
        pendingApprovals: "Ausstehende Freigaben",
        approved: "genehmigt",
        topic: "Thema",
        amountCHF: "Betrag CHF",
        remarks: "Bemerkungen",
        checklistTemplate: "Vorlage Checkliste",
        currentChecklist: "Aktuelle Checkliste",
        budget: "Mehr/Minderkostenabrechnung",
        total: "Total",
        buyers: "Käufer",
        buyerAssistance: "Käuferbetreuung",
        checklist: "Checkliste",
        apartmentStateChange: "Wohnungsstatus ändern",
        state: "Wohnungsstatus",
        apartmentStateDescription:
            "Der Wohnungsstatus legt fest, ob eine Wohnung bearbeitet werden kann",
        created: "Wohnung erstellt",
        updated: "Wohnung aktualisiert",
        buyerCreated: "Käufer erstellt",
        buyerDeleted: "Käufer entfernt",
        buyerUpdated: "Käufer aktualisiert",
        editBuyer: "Käufer bearbeiten",
        inviteSent: "Einladung versendet",
        buyer: "Käufer",
        buyerDescription: "Käufer der Wohnung",
        editAssistance: "Käuferbetreuung ändern",
        persons: "Käuferbetreuung",
        firstname: "Vorname",
        lastname: "Nachname",
        street: "Strasse",
        zip: "PLZ",
        city: "Ort",
        country: "Land",
        phone: "Mobile",
        email: "E-Mail",
        notify: "Benachrichtigen bei ausstehenden Freigaben, neuen Mitteilungen oder sonstigen Anpassungen",
        inviteNow: "Käufer jetzt einladen",
        notInvited: "nicht eingeladen",
        invite: "Einladen",
        addEmail: "E-Mail ergänzen",
        inviteNowHint: "Legt ein Zugangskonto an und verschickt die Einladung sofort. Ausgeschaltet wird der Käufer nur erfasst; einladen lässt er sich später in der Wohnung.",
        inviteNeedsEmail: "Braucht eine E-Mail-Adresse.",
        editApartment: "Wohnung bearbeiten",
        newBuyer: "Neuer Käufer",
        deleteBuyer: "Käufer löschen",
        confirmDeleteBuyer: "Sind Sie sicher, dass dieser Käufer gelöscht werden soll?",
        settings: "Einstellungen",
        deleteOffer: "Offerte löschen",
        confirmDeleteOffer: "Sind Sie sicher, dass diese Offerte gelöscht werden soll?",
        // Notizen als datierte Einträge (Thema 7,
        // docs/superpowers/specs/2026-08-04-welle1-notizen-eintraege-design.md).
        notes: "Notizen",
        notesSubtitle: "Gespräche, Termine und Entscheide zur Wohnung",
        newNote: "Neuer Eintrag",
        noteCategory: "Kategorie",
        noteCategories: {
            meeting: "Besprechung",
            call: "Telefonat",
            site: "Baustelle",
            email: "E-Mail",
            note: "Notiz",
        },
        noteMonths: {
            "01": "Januar",
            "02": "Februar",
            "03": "März",
            "04": "April",
            "05": "Mai",
            "06": "Juni",
            "07": "Juli",
            "08": "August",
            "09": "September",
            10: "Oktober",
            11: "November",
            12: "Dezember",
        },
        showAllNotes: "Alle anzeigen",
        noteTitle: "Titel",
        noteTitlePlaceholder: "Bemusterung Küche",
        noteDate: "Datum",
        noteParticipants: "Teilnehmende",
        noteParticipantsPlaceholder:
            "Freida McClure, Michèle von Vacano, R. Bieri (Küchenbau AG)",
        noteParticipantsHint: "Freitext — auch Externe wie Bauleitung oder Unternehmer.",
        noteBody: "Notiz",
        noteBodyPlaceholder: "Was wurde besprochen, entschieden, was ist offen?",
        noteCreated: "erfasst",
        noteEdited: "geändert",
        noteDeleteConfirm: "Diesen Eintrag löschen?",
        // Auftrag Luca, 2026-08-17, Entscheid 9: der Schalter benennt einen
        // ZUSTAND, nicht eine Handlung; das Kennzeichen in der Liste ist die
        // knappe Form davon.
        noteVisibleForBuyer: "Für Käufer sichtbar",
        noteVisibleBadge: "für Käufer",
        notesBuyerSubtitle: "Notizen, die Ihre Betreuung mit Ihnen geteilt hat",
        emptyNotes: "Keine Notizen vorhanden",
        offeredCHF: "Kosten CHF",
        // Auftrag Luca, 2026-08-25, Entscheide 1.1/1.2: im
        // budgetbasierten Modus heisst dieselbe Spalte «Offeriert».
        // Bewusst ein eigener Schluessel und keine Fallunterscheidung im
        // Wert — `locales.spec.js` wacht ueber die Schluesselgleichheit
        // de/en, und zwei benannte Schluessel sind dort pruefbar.
        quotedCHF: "Offeriert CHF",
        // Auftrag Luca, 2026-08-25, Entscheid 4.1: Kopf der Total-Spalte.
        // BEWUSST EIN EIGENER SCHLUESSEL neben `apartments.total`, obwohl
        // beide heute dasselbe Wort tragen (Nitpick des code-reviewers,
        // 2026-08-25, geprueft und beibehalten): `apartments.total`
        // beschriftet die Summe der offenen Freigaben
        // (`ApartmentsPendingApprovalsItems.vue`), dieser hier den Kopf einer
        // Tabellenspalte. Ein gemeinsamer Schluessel hiesse, dass keiner der
        // beiden Texte mehr geaendert werden kann, ohne den anderen
        // mitzunehmen.
        totalColumn: "Total",
        // Nacharbeit UI-2 (2026-08-25): die Schlusszeile der
        // Exkl.-Ansicht. Ohne sie stuende nirgends, was der Kaeufer
        // tatsaechlich ueberweist.
        totalInclVat: "Total inkl. MWST",
        budgetCHF: "Budget CHF",
        difference: "Mehrkosten",
        emptyNote: "Keine Notiz vorhanden",
        offered: "offeriert",
        priceInclVat: "Alle Preise inklusive MWST",
        personsDescription: "Käuferbetreuung dieser Wohnung",
        settingsDescription: "Wohungsweit gültige Parameter",
        // Auftrag Peter, 08.09.2026: durchgehend "Honorar".
        //
        // Bis dahin hiess es hier "Honorar" und in den Masken
        // "Bauleitungshonorar" — eine Ausnahme aus dem UI-Gate der Welle 2
        // (B-1, welle2-ui-report.md): der 18 Zeichen lange Kopf hatte die
        // Tabelle bei 768 px über ihren scrollbaren Vorfahren hinausgetrieben.
        // Der Grund entfällt, wenn das kurze Wort überall steht, und die
        // Anwendung nennt dieselbe Sache nicht mehr an zwei Orten verschieden.
        consultancyFee: "Honorar",
        baseFee: "Gebühr",
        subtotal: "Zwischensumme",
        inclVat: "inkl. MWST",
        // Themen 2-4 (Spec docs/superpowers/specs/2026-08-04-welle2-tabelle-detailebene-design.md):
        // MwSt-Umschalter + Detailebene der Abrechnungstabelle.
        exclVat: "exkl. MWST",
        taxInclLabel: "davon MWST",
        taxExclLabel: "zzgl. MWST",
        expandAll: "Alle aufklappen",
        collapseAll: "Alle zuklappen",
        separatorDeclined: "— ABGELEHNT —",
        separatorUnbilled: "— NICHT BERÜCKSICHTIGT —",
        floor: "Stockwerk",
        parking: "Parkplatz",
        parkingPlaceholder: "z. B. 14, 15",
        includedInPurchasePrice: "In Kaufpreis inbegriffenes Budget:",
        reminderSent: "Erinnerung wurde versendet",
        lastReminded: "Letzte Erinnerung:",
        buyerNotificationsNotActive:
            "Benachrichtigungen sind bei keinem Käufer aktiviert!",
        buyerNotificationsNotInvited:
            "Die zu benachrichtigenden Käufer sind noch nicht eingeladen!",
        resend: "Erneut einladen",
        inviteAccepted: "Einladung akzeptiert",
        inviteNotAccepted: "Einladung nicht akzeptiert",
        deleteApartmentTitle: "Wohnung löschen bestätigen",
        deleteApartmentDesc:
            "Soll diese Wohnung wirklich gelöscht werden? Achtung: Löschen ist nur möglich, wenn keine Bestellungsänderungen mehr vorliegen.",
        deleted: "Wohnung wurde gelöscht",
        communication: "Kommunikation",
        specifications: "Spezifikationen",
    },
    // Thema 1 (Spec docs/superpowers/specs/2026-08-04-welle2-spalten-sichtbarkeit-design.md):
    // Spalten-Sichtbarkeit Intern/Käufer — Projekt-Modal, Wohnungs-Modal und
    // die beiden Einstiege (ProjectsInfobar, ApartmentsBudget).
    columns: {
        title: "Spalten-Sichtbarkeit",
        manage: "Spalten verwalten",
        internal: "Intern",
        buyer: "Käufer",
        useDefault: "Projekt-Standard verwenden",
        projectDescription:
            "Legt fest, welche Spalten Wohnungen dieses Projekts standardmässig anzeigen.",
        apartmentDescription:
            "Legt fest, welche Spalten für diese Wohnung angezeigt werden. Ohne eigene Auswahl gilt der Projekt-Standard.",
        // Auftrag 2026-08-16, Entscheid 15: die Begründung nennt den
        // Berechnungsmodus bewusst NICHT — er ist ausschliesslich für den
        // Superadmin sichtbar.
        notHideable: "für diese Agentur nicht ausblendbar",
    },
    // Welle 3, Thema 6 (Spec docs/superpowers/specs/2026-08-04-welle3-thema6-exportmenue-design.md):
    // Export-Menü der Projektseite (Trigger + zwei XLSX-Downloads).
    exports: {
        menu: "Export",
        deadlines: "Offene Termine",
        buyers: "Käuferliste",
        // Welle 3, Thema 5 (Spec
        // docs/superpowers/specs/2026-08-04-welle3-thema5-excel-abrechnung-design.md):
        // Abrechnungs-Export — Wohnungs-Aktionsleiste (`ApartmentsBudget`) und
        // dritter Eintrag im Projekt-Export-Dropdown (`ProjectsInfobar`, Sammel).
        budget: "Abrechnung",
        // Welle 3, Thema 12 (Spec
        // docs/superpowers/specs/2026-08-04-welle3-thema12-archiv-zip-design.md):
        // vierter Eintrag — öffnet ein Auswahl-Modal statt direkt herunterzuladen.
        archive: "Archiv",
        archiveTitle: "Archiv exportieren",
        archiveDescription:
            "Wählt die Wohnungen aus, die als ZIP heruntergeladen werden sollen — je Wohnung Abrechnung und Dokumente, wahlweise Notizen und Chat-Verlauf.",
        archiveSelectAll: "Alle auswählen",
        archiveDeselectAll: "Alle abwählen",
        archiveWithNotes: "Notizen einschliessen",
        archiveWithChat: "Chat-Verlauf einschliessen",
        archiveNoSelection: "Mindestens eine Wohnung auswählen.",
        bkp: "Kosten nach BKP",
        bkpTitle: "Kosten nach BKP",
        bkpDescription:
            "Kostenmatrix nach Baukostenplan. Zeilen sind die BKP-Positionen, Spalten die Gebäude und Wohnungen. Ein Blatt je Gebäude.",
        bkpDescriptionNoBuildings:
            "Kostenmatrix nach Baukostenplan. Zeilen sind die BKP-Positionen, Spalten die Wohnungen.",
        bkpWithUnassigned: "Wohnungen ohne Gebäude einschliessen",
        bkpDisplay: "Darstellung",
        bkpSubgroupSheets: "Untergruppen als eigene Blätter",
        bkpSheetCount: "{count} Blätter in der Datei",
        bkpHideEmpty: "Leere BKP-Positionen ausblenden",
        bkpAmounts: "Beträge",
        bkpGross: "Inklusive MWST (brutto)",
        bkpNet: "Exklusive MWST (netto)",
        bkpOnlyBilled: "Nur verrechnete Bestellungsänderungen",
        bkpWithFees: "Gebühr und Honorar einbeziehen",
        bkpApartmentCount: "{count} Whg",
        bkpNoSelection: "Mindestens ein Gebäude auswählen.",
    },
    suppliers: {
        suppliers: "Unternehmer",
        supplier: "Unternehmer",
        supplierDetail: "Unternehmer Detail",
        newSupplier: "Neuen Unternehmer anlegen",
        inactiveSuppliers: "inaktive Unternehmer",
        name: "Name",
        website: "Webseite",
        street: "Strasse",
        zip: "PLZ",
        city: "Ort",
        country: "Land",
        firstname: "Vorname",
        lastname: "Nachname",
        email: "E-Mail",
        mobile: "Mobile",
        address: "Adresse",
        addressDescription: "Adresse des Unternehmers",
        contact: "Kontakt",
        contactDescription: "Verantwortliche Kontaktperson beim Unternehmer",
        editBase: "Unternehmer editieren",
        editContact: "Kontakt editieren",
        stateChange: "Status ändern",
        state: "Status",
        stateDescription: "Unternehmerstatus ändern",
        apartment: "Wohnung",
        topic: "Thema",
        projects: "Projekte",
        created: "Unternehmer erstellt",
        updated: "Unternehmer aktualisiert",
        offers: "Offerten",
        noSupplier: "ohne Unternehmer",
        stateActiveTitle: "Aktiv",
        stateActiveDescription:
            "Dieser Unternehmer steht in der Unternehmerauswahl zur Verfügung.",
        stateInactiveTitle: "Inaktiv",
        stateInactiveDescription:
            "Dieser Unternehmer wird in der Unternehmerauswahl ausgeblendet.",
        // Thema 9 (Welle 4, Paket c) — Firmendaten (email/phone) + Kontaktpersonen.
        phone: "Telefon",
        companyContact: "Firmenkontakt",
        companyContactDescription:
            "Allgemeine Kontaktdaten des Unternehmens (E-Mail, Telefon)",
        contacts: "Kontaktpersonen",
        contactsDescription: "Kontaktpersonen dieses Unternehmers",
        contactPerson: "Kontaktperson",
        noContactSelected: "Keine Kontaktperson ausgewählt",
        noContactsYet: "Noch keine Kontaktpersonen erfasst.",
        addSupplier: "Unternehmer hinzufügen",
        supplierOptional: "optional",
        chooseCountry: "Land wählen…",
        addContact: "Kontaktperson hinzufügen",
        newContact: "Neue Kontaktperson",
        // Eigener Schluessel fuer den PLATZHALTER des Auswahlfelds:
        // `noContactsYet` bleibt ein Satz (mit Punkt) und wird als Fliesstext
        // in Suppliers/Show und Suppliers/Modals/Contact weiterverwendet — im
        // Feld selbst stuende der Punkt neben dem punktlosen Gegenstueck.
        noContactsYetShort: "Noch keine Kontaktperson erfasst",
        removeContact: "Kontaktperson entfernen",
        contactFallbackNotice: "Firmenkontakt (kein direkter Kontakt hinterlegt)",
        // ANFORDERUNGEN-V2 V2-09: Beschriftung und Verweis im
        // Unternehmer-Block des Themenkopfs. EIGENER Schluessel — `contactPerson`
        // ("Kontaktperson") existiert oben bereits und beschriftet vier
        // Formulare (drei Offerten-Modale, Modal "Unternehmer bearbeiten");
        // ein zweiter gleichnamiger Eintrag haette sie still ueberschrieben.
        contactPersonHeading: "Ansprechperson",
        openAllDetails: "Alle Angaben öffnen →",
        contactCreated: "Kontaktperson erstellt",
    },
    topics: {
        active: "Aktiv",
        name: "Name",
        budget: "Budget",
        editBudget: "Budget bearbeiten",
        budgetDescription: "Budget für dieses Thema",
        deadline: "Termin",
        editDeadline: "Termin bearbeiten",
        deadlineDescription:
            "Letzt möglicher Termin zur Annahme der Offerte durch den Kunden.",
        supplier: "Unternehmer",
        editSupplier: "Unternehmer bearbeiten",
        supplierDescription: "Unternehmer für dieses Thema",
        comment: "Bemerkung",
        note: "Hinweis",
        noteText:
            "Änderungen an untenstehenden Themen gelten für alle neuen Wohnungen. Auf bestehende Wohnungen können sie nach dem Speichern übertragen werden.",
        templates: "Vorlagen",
        info: "Information",
        plandata: "Plandaten",
        offer: "Offerte",
        offerDescription: "Details zur Offerte",
        offers: "Offerten",
        offered: "Offeriert",
        date: "Datum",
        difference: "Mehrkosten",
        inclVat: "Preise inklusive MWST.",
        documents: "Dokumente",
        version: "Version",
        state: "Status",
        viewFileHistory: "Versionshistorie",
        fileHistory: "Versionen",
        fileHistoryDescription: "Unterschiedliche Versionen dieser Datei",
        updated: "Thema aktualisiert",
        stateChange: "Status ändern",
        topicsStateChange: "Themenstatus ändern",
        topicsStateDescription: "Status zu diesem Thema anpassen",
        emptyInfo: "Kein Informationstext hinterlegt.",
        emptyOffers: "Noch keine eine Offerte erfasst.",
        emptySupplier: "ohne Unternehmer",
        emptyBudget: "Noch kein Budget festgelegt.",
        emptyDeadline: "Kein Termin definiert.",
        emptyDocuments: "Keine Dokumente vorhanden.",
        editDescription: "Themenbeschreibung bearbeiten",
        description: "Beschreibung",
        offerTitle: "Bezeichnung",
        editInclusiveBudget: "Inklusivbudget bearbeiten",
        inclusive_budget: "Inklusivbudget",
        inclusive_reference: "Bezugsgrösse",
        inclusive_unit: "Einheit",
        inclusiveBudget: "Inklusivbudget",
        // Auftrag 2026-08-16, Entscheid 13: Leerfall des Themenkopfs, wenn die
        // Budget-Funktion ausgeblendet ist.
        withoutInclusiveBudget: "ohne Inklusivbudget",
        inclusiveBudgetDescription:
            "Das Inklusivbduget umfasst Leistungen, die im Kaufpreis inbegriffen sind. Die Angabe einer Bezugsgrösse und Einheit ist nur notwendig, wenn ein Preis pro Einheit ausgewiesen werden soll (Beispiel: Inklusivbudget CHF 5000, Bezugsgrösse 100, Einheit m2 => CHF 50.00 / m2)",
        includedInPurchasePrice: "Im Kaufpreis inbegriffen:",
        icon: "Icon",
        noTopic: "Noch kein Thema erfasst",
        noTopicDesc: "Bitte klicken Sie auf hinzufügen, um ein Thema einzufügen.",
        editIcon: "Themenicon ändern",
        bkp: "BKP",
        disable_calculation: "Gebührenberechnung deaktivieren",
        orderModification: "Bestellungsänderung",
        orderModificationDescription: "Details zur Bestellungsänderung",
    },
    orderModifications: {
        new: "Neue Bestellungsänderung",
        title: "Bezeichnung",
        comment: "Beschreibung",
        description: "Beschreibung",
        orderModification: "Bestellungsänderung",
        orderModifications: "Bestellungsänderungen",
        state: "Status",
        emptyOrderModifications: "Keine Bestellungsänderungen vorhanden",
        vatInfo: "Preise inklusive gesetzlicher Mehrwertsteuer",
        cost: "Kosten",
        // Auftrag Luca, 2026-08-25, Entscheid 1.1: dieselbe Spalte im
        // budgetbasierten Modus.
        quoted: "Offeriert",
        showDetails: "Details anzeigen",
        created: "erstellt",
        update: "Bestelläungsänderung bearbeiten",
        budget: "Budget",
        difference: "Differenz",
        approval: "Genehmigung",
        approvalInfo:
            "Verbindliche Genehmigung dieser Bestellungsänderung durch die Kundschaft",
        approve: "Bestellungsänderung genehmigen",
        decline: "Bestellungsänderung ablehnen",
        declinedMessage: "Bestellungsänderung abgelehnt",
        declinedReason: "Begründung:",
        orderModificationNotSent: "Bestellungsänderung noch nicht gesendet!",
        orderModificationNotSentDesc:
            "Bitte drücken Sie den Senden-Button, um die Bestellungsänderung der Käuferschaft zwecks Genehmigung zuzustellen.",
        orderModificationDecision: "Bitte genehmigen Sie die Bestellungsänderung",
        orderModificationDecisionDesc:
            "Bitte prüfen Sie alle Offerten sorgfältig und genehmigen Sie die Bestellungsänderung (alle Offerten) oder lehnen Sie sie mit Begründung ab. Mit Genehmigung der Bestellungsänderung erteilen Sie uns einen verbindlichen Auftrag zur Ausführung der in dieser Bestellungsänderung aufgeführten Offerten.",
        orderModificationApproved: "Bestellungsänderung genehmigt",
        orderModificationApprovedDesc:
            "Die Bestellungsänderung wurde zur Ausführung genehmigt",
        send: "Bestellungsänderung senden",
        by: "von",
        at: "am",
        oclock: "Uhr",
        backTo: "Zurück zu",
        deleteOrderModificationTitle: "Bestellungsänderung löschen bestätigen",
        deleteOrderModificationDesc:
            "Soll diese Bestellungsänderung inklusive aller Offerten und Freigaben gelöscht werden? Dieser Schritt kann nicht rückgängig gemacht werden!",
        deleted: "Bestellungsänderung gelöscht",
        updated: "Bestellungsänderung aktualisiert",
        pendingSignatures: {
            title: "Signaturen ausstehend",
            boxDescription:
                "Einige Offerten in dieser Änderung erfordern digitale Signaturen. Alle Käufer müssen unterschreiben, bevor diese Änderung genehmigt werden kann.",
            showAdvisor: "Erinnerungen anzeigen und erneut senden",
            showBuyer: "Ausstehende Signaturen anzeigen",
            modalTitle: "Ausstehende Unterschriften der Käufer",
            introAdvisor:
                "Die folgenden Käufer haben die Angebotsunterlagen noch nicht unterzeichnet. Bitte stellen Sie sicher, dass alle Unterschriften vor der Genehmigung vorliegen.",
            introBuyer:
                "Die folgenden Unterschriften stehen noch aus. Die Änderung kann erst genehmigt werden, wenn alle Käufer unterzeichnet haben.",
            colOffer: "Offerte",
            colBuyer: "Käufer",
            colAction: "Aktion",
            rejected: "Abgelehnt",
            sending: "Wird gesendet...",
            resendEmail: "E-Mail erneut senden",
            signNow: "Jetzt unterzeichnen",
            signNowFor: "Für {name} unterschreiben",
            approvalBlocked:
                "Genehmigung blockiert, bis alle Käufer unterschrieben haben.",
            signDocument: "Dokument signieren",
            signingDone: "Unterzeichnung abgeschlossen",
            signHint:
                "Klicken Sie im Signaturfenster auf die grüne Schaltfläche „Fertig“ oder „Abschließen“, sobald Sie fertig sind.",
            signatureProcessed: "Unterschrift verarbeitet.",
            reminderSent: "Erinnerungs-E-Mail versendet.",
            reminderFailed: "E-Mail konnte nicht erneut versendet werden.",
            genericError: "Etwas ist schiefgelaufen.",
        },
        confirmApprove: {
            title: "Offerte verbindlich freigeben",
            question: "Sind Sie sicher, dass Sie diese Offerte freigeben möchten?",
            description:
                "Mit der Freigabe bestätigen Sie die Offerte verbindlich. Die Offerte kann anschliessend nicht mehr bearbeitet oder zurückgezogen werden.",
            confirm: "Verbindlich freigeben",
        },
        states: {
            created: "Erstellt",
            readyForApproval: "Entscheid",
            approved: "Freigegeben",
            declined: "Abgelehnt",
            replaced: "Ersetzt",
        },
    },
    offers: {
        title: "Bezeichnung",
        customBkp: "Sonstige BKP",
        number: "Offerten Nr.",
        cost: "Betrag exkl. MWST",
        type: {
            label: "Art",
            offer: "Offerte",
            credit: "Gutschrift",
            creditHint: "Wird als negativer Betrag (−CHF) gebucht.",
        },
        applyBaseFee: "Gebühr auf diese Offerte berücksichtigen",
        applyConsultancyFee: "Honorar auf diese Offerte berücksichtigen",
        // K-3 (UI-Gate Welle 2, welle2-ui-report.md): gemeinsame
        // Gruppenbeschriftung der beiden Fee-Checkboxen oben.
        feeFlagsLabel: "Verrechnung",
        comment: "Bemerkung",
        created: "Offerte wurde erstellt",
        updated: "Offerte wurde aktualisiert",
        replaced: "Neue Offerte angelegt",
        deleted: "Offerte wurde gelöscht",
        file: "Offerte",
        fileInfo: "PDF / ZIP (max. {size} MB)",
        fileTooBig: "Die Datei ist zu gross!",
        // Zu signierende Offerten unterliegen einer engeren Grenze
        // (`core.max_signed_offer_upload_size`) — der Hinweis nennt sie, damit
        // sie nicht erst beim Absenden auffaellt.
        fileInfoSigned: "PDF (max. {size} MB — zu signierende Offerten)",
        signedFileTooBig: "Zu signierende Offerten: max. {size} MB.",
        fileTypeInvalid: "Dieser Dateityp wird nicht unterstützt.",
        // Fix Welle 4.5 UI-Gate (welle45-ui-report.md, blockierender Befund):
        // ersetzt den vormals hartkodierten, unübersetzten englischen String
        // "Digital signature requires PDF.".
        digitalSignatureRequiresPdf:
            "Die digitale Signatur ist nur für PDF-Dateien möglich.",
        digitalSignatureRequired: "Digitale Signatur benötigt?",
        replace: "Bestehende Offerte ersetzen",
        new: "Offerte hinzufügen",
        edit: "Offerte bearbeiten",
        supplier: "Unternehmer",
        declineOffer: "Offerte ablehnen",
        bkps: "BKP-Nummer",
        date: "Datum",
        state: {
            created: "Erstellt",
            readyForApproval: "Entscheid",
            approved: "Freigegeben",
            declined: "Abgelehnt",
            replaced: "Ersetzt",
        },
        decline: "Offerte ablehnen",
        declineDescription: "Offerte nicht akzeptieren",
        declineOfferConfirm: "Möchten Sie diese Offerte wirklich ablehnen?",
        reason: "Begründung",
        showComment: "Kommentar anzeigen",
        offerNotSent: "Offerte noch nicht gesendet",
        offerNotSentDesc:
            "Bitte drücken Sie den Senden-Button, um die Offerte der Käuferschaft zuzustellen.",
        offerNotApproved: "Offerte nicht freigegeben",
        offerNotApprovedDesc:
            "Bitte prüfen Sie die eingereichte Offerte und geben Sie diese frei.",
        description: "Bezeichnung",
        bkpTitle: "BKP",
        actions: "Aktionen",
        version: "Version",
        totalWithTax: "Total inkl. MWST",
        totalWithoutTax: "Total exkl. MWST",
        taxAmount: "MWST",
        taxRate: "MWST-Satz",
        netCost: "Betrag exkl. MWST",
        vatInfo:
            "Die Mehrwertsteuer richtet sich nach dem bei Leistungserbringung gültigen Satz.",
        bkp: {
            N211: "211 Rohbau Baumeister",
            N215_5: "215.5 Fassadenverkleidung",
            N221: "221 Fenster",
            N221_8: "221.8 Balkonverglasung",
            N224_1: "224.1 Flachdach / Abdichtung",
            N224_3: "224.3 Glaseinbauten in Flachdächer",
            N228_1: "228.1 Sonnenschutz",
            N228_5: "228.5 Insektenschutz",
            N230: "230 Elektro",
            N240: "240 Heizung",
            N244: "244 Lüftung",
            N250: "250 Sanitär",
            N252: "252 WM + Tumbler",
            N258: "258 Küche",
            N271_0: "271.0 Gipser Verputzarbeiten",
            N271_1: "271.1 Gipser Trockenbau",
            N273_0: "273.0 Innentüren",
            N273_1: "273.1 Einbauschränke",
            N273_3: "273.3 Allgemeine Schreinerarbeiten",
            N274: "274 Metallbau und Verglasungen",
            N275: "275 Schliessanlage",
            N281_0: "281.0 Unterlagsböden",
            N281_4: "281.4 Bodenbeläge Naturstein",
            N281_6: "281.6 Bodenbeläge Platten",
            N281_7: "281.7 Bodenbeläge Holz",
            N282_4: "282.4 Wandbeläge Naturstein",
            N282_6: "282.6 Wandbeläge Platten",
            N284: "284 Cheminée / Ofen",
            N285: "285 Malerarbeiten",
            N288: "288 Gärtnerarbeiten Gebäude",
            N291_0: "291.0 Architekt",
            N291_1: "291.1 Bauleitung",
            N291_2: "291.2 Honorar Käuferwünsche",
            N292: "292 Bauingenieur",
            N293: "293 Elektroingenieur",
            N294: "294 HLKS-Ingenieur",
            N297_3: "297.3 Bauphysiker",
            N298_5: "298.5 Brandschutzingenieur",
            N299: "299 Käuferbetreuung",
            N421: "421 Gärtnerarbeiten Umgebung",
            N810: "810 Honorare Architekt",
            N820: "820 Honorare Bauingenieur",
            N830: "830 Honorare Elektroingenieur",
            N840: "840 Honorare HLK-Ingenieur",
            N850: "850 Honorare Sanitäringenieur",
            none: "keine",
            other: "sonstige BKP",
        },
        priceCalc: {
            addButton: "Preisberechnung hinzufügen",
            editButton: "Preisberechnung bearbeiten",
            viewTitle: "Preisberechnung anzeigen",
            unit: "Einheit",
            pricePerUnit: "Preis pro Einheit",
            amount: "Menge",
            total: "Total exkl. MwSt",
            selectUnit: "Einheit wählen",
            errorUnit: "Einheit ist erforderlich.",
            errorPricePerUnit: "Preis pro Einheit ist erforderlich.",
            errorAmount: "Menge ist erforderlich.",
            errorCostZero: "Betrag muss mindestens 0 sein.",
            errorMismatch:
                "Der Betrag exkl. MWST stimmt nicht mit dem Total der Preisberechnung überein.",
            rowCount: "({count} Positionen)",
        },
    },
    documents: {
        title: "Dokumente",
        file: "Datei",
        comment: "Bemerkung",
        document: "Dokument",
        documentDescription: "Dokumente für die Käuferschaft",
        fileInfo: "{extensions} (max. {size} MB)",
        fileTooBig: "Die Datei ist zu gross!",
        fileTypeInvalid: "Dieser Dateityp wird nicht unterstützt.",
        // Toast kuerzt bei 100 Zeichen: knapp die Grenze nennen.
        signedFileTooBig: "Zu signierende Dokumente: max. {size} MB.",
        name: "Bezeichnung",
        version: "Version",
        date: "Datum",
        emptyDocuments: "Keine Dokumente vorhanden",
        new: "Dokument anlegen",
        created: "Dokument angelegt",
        updated: "Dokument aktualisiert",
        deleted: "Dokument gelöscht",
        showComment: "Kommentar anzeigen",
        edit: "Dokument bearbeiten",
        deleteDocument: "Dokument löschen",
        confirmDeleteDocument: "Möchten Sie dieses Dokument wirklich löschen?",
        replace: "Dokument ersetzen",
        sign: "Dokument signieren",
        finishedSigning: "Ich habe fertig signiert",
        clickGreenButton: "Bitte klicken Sie den grünen Button nach Abschluss.",
        downloadingForSigning:
            "Neueste Dokumentversion wird für die Signatur heruntergeladen...",
        errorCouldNotStartSelfSign: "Selbstsignatur konnte nicht gestartet werden.",
        errorCheckingStatus: "Fehler beim Prüfen des Status.",
        errorCompleteSignatureFirst: "Bitte zuerst die Signatur abschliessen.",
        errorSelectBuyer: "Mindestens einen Käufer auswählen.",
        errorAssignBoxToBuyer: "Jedes Feld einem Käufer zuordnen.",
        errorSendingDocument: "Fehler beim Versenden des Dokuments.",
        errorLimitReached: "Limit erreicht",
        errorTooManyBuyers: "Es können maximal :max Käufer ausgewählt werden.",
        errorNotAllowed: "Nicht erlaubt",
        errorBuyerNotInvited:
            "Dieser Käufer wurde noch nicht eingeladen und kann noch nicht als Unterzeichner ausgewählt werden.",
        buyerNotInvitedBadge: "Noch nicht eingeladen",
        uninvitedBuyersHidden:
            "Noch nicht eingeladene Käufer erscheinen hier nicht — bis zur Einladung geht nach aussen nichts.",
        errorSelfSignCompleted:
            "Selbstsignatur bereits abgeschlossen. Eigene Felder können nicht kopiert werden.",
        digitalSignature: "Digitale Signatur",
        // Welle 4, Thema 8 (Spec
        // docs/superpowers/plans/2026-08-05-welle4-thema8-dokumente-verteilen.md):
        // Dokumente von der Projektebene auf mehrere Wohnungen verteilen.
        distribute: "Dokumente verteilen",
        distributeTitle: "Dokumente verteilen",
        distributeDescription:
            "Lädt ein Dokument hoch und verteilt es an mehrere Wohnungen — entweder direkt an die Übersicht oder an ein per Namen gematchtes Thema.",
        distributeTarget: "Ziel",
        distributeTargetOverview: "Übersicht (direkt an der Wohnung)",
        distributeTargetTopic: "Thema (per Namen zugeordnet)",
        distributeTopicName: "Thema",
        distributeTopicPlaceholder: "Thema auswählen",
        distributeApartments: "Wohnungen",
        distributeScopeAll: "Alle ({count})",
        distributeScopeSelection: "Auswahl",
        distributeSummary: "Wird an {count} Wohnung(en) verteilt — Ziel: {target}.",
        distributeNotify: "Käufer benachrichtigen",
        distributeSubmit: "Verteilen",
        distributeResultSummary: "{distributed} von {total} Wohnungen beliefert",
        distributeSkipped: "Übersprungen",
        distributeSkipReasons: {
            noMatchingTopic: "Kein aktives Thema mit diesem Namen",
            error: "Fehler beim Verteilen",
            notFound: "Wohnung nicht gefunden",
        },
    },
    contact: {
        company: "Firma",
        firstname: "Vorname",
        lastname: "Nachname",
        email: "E-Mail",
        mobile: "Mobile",
    },
    templates: {
        title: "Vorlagen",
        newTemplate: "Neue Vorlage anlegen",
        copyTemplate: "Vorlage kopieren",
        renameTemplate: "Vorlage umbenennen",
        name: "Name",
        template: "Vorlage",
        templateDescription: "Bezeichnung der Vorlage",
        topics: "Themen",
        editTitle: "Vorlage bearbeiten",
        created: "Vorlage erstellt",
        updated: "Vorlage aktualisiert",
        deleted: "Vorlage gelöscht",
        deleteTemplate: "Vorlage löschen",
        markedDefault: "Vorlage als Standard gesetzt",
    },
    actions: {
        save: "Speichern",
        saved: "Gespeichert",
        delete: "Löschen",
        back: "Zurück",
        update: "Aktualisieren",
        add: "Hinzufügen",
        cancel: "Abbrechen",
        remind: "Erinnern",
        upload: "Hochladen",
        edit: "Bearbeiten",
        seeMore: "mehr sehen",
        reset: "Zurücksetzen",
        success: "Erfolg!",
        error: "Fehler!",
        defaultError: "Aktion konnte nicht durchgeführt werden",
        decline: "Ablehnen",
        chooseFile: "Datei auswählen",
        removeFile: "Datei entfernen",
        close: "Schliessen",
        enable: "Aktivieren",
        disable: "Deaktivieren",
        done: "Erledigt",
        select: "Auswählen",
        remove: "Entfernen",
        revoke: "Zurückziehen",
        notAvailable: "Nicht verfügbar",
        added: "Hinzugefügt",
        apply: "Anwenden",
        copy: "Kopieren",
        download: "Herunterladen",
        view: "Ansehen",
        open: "Öffnen",
        yes: "Ja",
        no: "Nein",
        saving: "Wird gespeichert...",
        leave: "Verlassen",
        notSavedChanges: "Ungespeicherte Änderungen",
        notSavedChangesDesc:
            "Bitte auf «Speichern» drücken, um die Änderungen zu übernehmen.",
        leaveTitle: "Ohne Speichern verlassen?",
        leaveText:
            "Die Änderungen an den Themen sind noch nicht gespeichert. Wenn Sie die Seite verlassen, gehen sie verloren.",
        leaveWithoutSaving: "Ohne Speichern verlassen",
        keepEditing: "Weiter bearbeiten",
        saveFirst: "Zuerst speichern",
        confirm: "Bestätigen",
        next: "Weiter",
        previous: "Zurück",
    },
    forms: {
        optional: "Optional",
        selectCountry: "Land wählen...",
        dropFileHint: "Datei hierher ziehen oder oben auswählen",
        dropFileActive: "Datei hier ablegen",
    },
    dialogs: {
        deleteProject: "Möchten Sie dieses Projekt unwiderruflich löschen?",
        deleteTemplate: "Möchten Sie diese Vorlage unwiderruflich löschen?",
        somethingWentWrong: "Whoops! Etwas ist schiefgelaufen!",
        sendFeedback: "Feedback senden",
    },
    states: {
        open: "offen",
        in_process: "in Bearbeitung",
        blocked: "blockiert",
        completed: "abgeschlossen",
        active: "aktiv",
        inactive: "inaktiv",
        archived: "archiviert",
    },
    agencies: {
        clearTitle: "Agenturen bereinigen",
        search: "Suchen",
        deleteSelected: "Ausgewählte löschen",
        confirmDeleteSelected: "Möchten Sie die ausgewählten Agenturen wirklich löschen?",
        title: "Agenturen",
        edit: "Bearbeiten",
        updated: "Agentur wurde aktualisiert",
        name: "Firma",
        ownerFirstname: "Vorname",
        ownerLastname: "Nachname",
        ownerEmail: "E-Mail",
        ownerMobile: "Mobile",
        inviteSent: "Einladung erfolgreich versendet",
        inviteDeleted: "Einladung erfolgreich gelöscht",
        roleUpdated: "Rolle wurde aktualisiert",
        advisorRemoved: "Mitglied erfolgreich entfernt",
        newAgency: "Neue Agentur anlegen",
        created: "Agentur erfolgreich erstellt",
        saveAndInvite: "Speichern & Einladen",
        agency: "Agentur",
        agencyDescription:
            "Eine Agentur besteht aus einem Team, welches selbständig Käufer betreut.",
        editAgency: "Agentur bearbeiten",
        addTeamMember: "Mitglied hinzufügen",
        inviteMember: "Mitglied einladen",
        teamMembers: "Teammitglieder",
        teamMembersDescription: "Diese Personen sind Mitglieder des Agentur-Teams.",
        pendingTeamInvitations: "Ausstehende Teameinladungen",
        pendingTeamInvitationsDesc:
            "Diese Personen sind in Ihr Team eingeladen worden und haben eine Einladungs-E-Mail erhalten. Sie können dem Team beitreten, indem sie die E-Mail-Einladung Einladung annehmen.",
        member: "Mitglied",
        memberDescription: "Ein neues Teamitglied zur Mitarbeit in der Agentur einladen.",
        firstname: "Vorname",
        lastname: "Nachname",
        email: "E-Mail",
        role: "Rolle",
        mobile: "Mobile",
        leaveTeam: "Team verlassen",
        confirmLeaveTeam: "Sind Sie sicher, dass Sie dieses Team verlassen möchten?",
        removeTeamMember: "Teammitglied entfernen",
        confirmRemoveTeamMember:
            "Sind Sie sicher, dass Sie diese Person aus dem Team entfernen möchten?",
        manageRole: "Rolle verwalten",
        // Auftrag 2026-08-16, Entscheide 5 und 6: nur der Superadmin sieht
        // diesen Block. Der Bestätigungstext nennt die Folge beim Namen.
        feeCalculationMode: "Berechnung von Gebühr und Honorar",
        // Auftrag Luca, 2026-08-20, Entscheid 4: der Wert BINDET die Projekte
        // nicht mehr, er ist die VOREINSTELLUNG fuer neu angelegte. Bestehende
        // Projekte bleiben unberuehrt; welchen Modus eines rechnet, steht auf
        // dessen Detailseite.
        feeCalculationModeDescription:
            "Legt die Voreinstellung fest, mit der NEU angelegte Projekte dieser Agentur Gebühr und Honorar rechnen. Bestehende Projekte bleiben unberührt — die Berechnungsart wird beim Anlegen eines Projekts gewählt und steht auf dessen Detailseite.",
        feeCalculationModeDefaultBadge: "Standard",
        feeCalculationModeExceptionHint: "Nur in Ausnahmefällen.",
        feeCalculationModes: {
            offer_based: "Offertenbasiert",
            budget_based: "Budgetbasiert",
        },
        feeCalculationModeHints: {
            offer_based:
                "Grundlage ist die Netto-Summe der angehakten Offerten der verrechneten Bestellungsänderungen. Das Budget spielt in der Rechnung keine Rolle.",
            // Fix-Runde nach dem ui-validator (K3, 2026-08-20): hier stand
            // «brutto». Seit der Netto-Umstellung vom 2026-08-18 ist die Basis
            // NETTO (`Kosten netto − Budget netto`, Docblock von
            // `FeeCalculationMode`); den Normalsatz schlägt der
            // `ApartmentCostCalculator` eine Ebene höher auf. Der Text war
            // damit seit zwei Tagen falsch und widersprach zusätzlich dem
            // gleichlautenden Hinweis auf der Projektseite.
            budget_based:
                "Grundlage sind die Mehrkosten (Kosten abzüglich Budget, netto). Die Häkchen «Gebühr berechnen» und «Honorar berechnen» je Offerte entfallen.",
        },
        feeCalculationModeConfirmTitle: "Berechnungsart wirklich umstellen?",
        // Fix-Runde nach dem Security-Gate (2026-08-17, Befund 4): der Text
        // nennt neu auch die SICHTBARKEITS-Folge. Im Budget-Modus ist die
        // Spalte «Budget» nicht ausblendbar — ein für Käufer ausgeblendetes
        // Budget wird damit wieder sichtbar, und zwar in einer fremden
        // Agentur, deren Käufersicht der Superadmin hier umschaltet.
        feeCalculationModeConfirmText:
            "Sämtliche Abrechnungen dieser Agentur werden ab sofort neu gerechnet — auch abgeschlossene Wohnungen und bereits versandte Exporte. Erfasste Budgets und die Häkchen je Offerte bleiben gespeichert. Im budgetbasierten Modus ist die Spalte «Budget» nicht ausblendbar: ein für Käufer ausgeblendetes Budget wird dort wieder sichtbar.",
        feeCalculationModeUpdated: "Berechnungsart wurde umgestellt",
        switchAgency: "Zur Agentur wechseln",
        active: "akitv",
        inactive: "inaktiv",
        activateAgency: "Agentur aktivieren",
        deactivateAgency: "Agentur deaktiveren",

        deactivateAgencyInfo:
            "Nach dem Deaktivieren kann diese Agentur, solange sie nicht reaktiviert wird, nicht weiter verwendet werden. Bitte folgende Punkte berücksichtigen:",
        deactivateAgencyInfoPoint1:
            "Benutzer, die nur diese Agentur haben, können die App nicht mehr nutzen. Käuferbetreuer, die nur dieser Agentur zugewiesen sind, können IMMIVO anschliessend nicht mehr verwenden.",
        deactivateAgencyInfoPoint2:
            "Käuferbetreuer, die weiteren Agenturen zugewiesen sind, müssen diese beim nächsten Login auswählen.",
        deactivateAgencyInfoPoint3:
            "Käufer haben weiterhin Zugang zu ihren Kaufobjekten.",
        deactivated: "Agentur deaktivert",
        activate: "Agentur aktivieren",
        activated: "Agentur aktiviert",
        activateInfo: "Möchten Sie diese Agentur wieder aktivieren?",
        deleteAgency: "Agentur löschen",
        noAgency: "Keine Agentur",
        noAgencyInfo:
            "Ihrem Benutzer ist keine Agentur zugeordnet. <br /> Falls dies ein Fehler ist, wenden Sie sich bitte an die Administration.",
        joinAgency: "Agentur beitreten",
        joinAgencyInfo: "Bitte wählen Sie eine Agentur:",
        deactivateDeleteAgency: "Agentur deaktiveren / löschen",
        deactivateDeleteAgencyDesc:
            "Beim Deaktivieren wird der Zugang zu den Projekten dieser Agentur blockiert ohne diese zu löschen.",
        deleteAgencyConfirmTitle: "Agentur löschen bestätigen",
        deleteAgencyConfirmDesc:
            "Mit bestätigen dieser Aktion wird sowohl die Agentur als auch Agentur-Benutzer gelöscht. Dieser Schritt kann nicht rückgängig gemacht werden. Im Zweifelsfall wird dazu geraten, die Agentur zu deaktivieren.",
        affectedUsers: "Folgende Benutzerkonten werden mitgelöscht:",
        deleted: "Agentur gelöscht",
        branding: "Branding",
        brandingSettings: "Branding Einstellungen",
        logo: "Logo",
        navbarColor: "Navbar Farbe",
        sidebarColor: "Sidebar Farbe",
        navbarTextColor: "Navbar Text Farbe",
        sidebarTextColor: "Sidebar Text Farbe",
        emailBackgroundColor: "Email Hintergrundfarbe",
        publish: "Veröffentlichen",
        resetToDefault: "Auf Standard zurücksetzen",
        preview: "Vorschau",
        resendInvitation: "Einladung senden",
        sendingInvitation: "Wird gesendet...",
        invitationSent: "Gesendet!",
        invitationResent: "Einladung wurde erfolgreich versendet",
        primaryOwner: "Hauptinhaber",
        makeSomeoneElsePrimaryOwner:
            "Legen Sie jemand anderen als Besitzer fest, bevor Sie die Agentur verlassen",
        transferPrimaryOwnership: "Hauptinhaber übertragen",
        transferPrimaryOwnershipDesc:
            "Bitte wählen Sie einen neuen Hauptinhaber aus der Liste unten aus, bevor Sie die Agentur verlassen.",
    },
    options: {
        option: "Option",
        optionDescription: "Auswahloption für Kunden",
        options: "Optionen",
        optionSets: "Options-Sets",
        name: "Interne Bezeichnung",
        description: "Beschreibung",
        title: "Bezeichnung",
        inactiveOptions: "Zeige inaktive",
        set: "Set",
        setDescription:
            "Ein Set ist eine Zusammenstellung von Optionen, welche dem Kunden zwecks Vorauswahl präsentiert werden.",
        newSet: "Neues Set",
        assignSet: "Set zuweisen",
        newOption: "Neue Option",
        editOption: "Option bearbeiten",
        deleteOption: "Option löschen",
        updated: "Option aktualisiert",
        deleted: "Option gelöscht",
        orderUpdated: "Reihenfolge aktualisiert",
        setUpdated: "Set aktualisiert",
        created: "Set erfolgreich erstellt",
        cost: "Kostenangabe",
        infotext: "Infotext",
        infoimages: "Infobilder",
        images: "Bilder",
        price: "Preis",
        optionName: "Name",
        state: "Status",
        stateChange: "Status ändern",
        preselected: "Vorauswahl",
        optionSetState: "Options-Set Status",
        changeOrder: "Reihenfolge ändern",
        unit: "Einheit",
        optionSetStateDescr:
            "Mit dem Options-Set Status wird festgelegt, ob das Set Themen zugewiesen werden kann.",
        optionInfoText:
            "Diese Option ist bereits im Einsatz. Bei einer Aktualisierung werden die Daten für alle im Einsatz befindlichen Optionen übernommen. Wird die Option deaktiviert, kann sie nicht mehr ausgewählt werden.",
        galleryTitle: "Mustergallerie",
        warningInUse:
            "Diese Option kann nicht gelöscht werden, da sie noch in Verwendung ist!",
        confirmDelete: "Wollen Sie diese Option wirklich löschen?",
        editImages: "Bilder verwalten",
        imageAdded: "Bild hinzugefügt",
        imageRemoved: "Bild gelöscht",
        addImage: "Bild hochladen",
        imageMadeDefault: "Bild als Standard gesetzt",
        fileTooBig: "Die Datei ist zu gross!",
        previewImage: "Vorschaubild",
        asPreviewImage: "Als Vorschaubild",
        of3ImagesUploaded: "von 3 Bildern hochgeladen",
        noImageUploaded: "...noch kein Bild Hochgeladen",
        maxFilesize: "JPG / PNG (max. {size} MB)",
        infoimagesText:
            "Hier können informative Bilder und Grafiken hinterlegt werden. Zum Beispiel Bilder zu Verlegerichtungen bei Parkettböden.",
        setDeleted: "Set gelöscht",
        internal_note: "Interne Notiz",
        setDelete: "Options-Set Löschen",
        setDeleteConfirm: "Möchten Sie das Options-Set wirklich löschen?",
        showInfo: "Informationen anzeigen",
    },
    set: {
        set: "Set",
        setDescription: "Eigenschaften dieses Sets",
        name: "Name",
        title: "Titel",
        description: "Beschreibung",
        internal_note: "Interne Notiz",
        external: "Extern",
        options: "Optionen",
        option: "Option",
    },
    profile: {
        profile: "Profil",
        profileInformation: "Profil Information",
        profileInformationInfo:
            "Aktualisieren Sie die Profilinformationen und die E-Mail-Adresse Ihres Kontos.",
        twoFactorAuthActivated: "2-Faktor Anmeldung aktiviert",
        photo: "Foto",
        selectNewPhoto: "Neues Foto Selektieren",
        removePhoto: "Foto entfernen",
        cropPhoto: "Profilbild zuschneiden",
        crop: "Zuschneiden",
        cropInstructions:
            "Ziehen Sie das Quadrat und passen Sie die Grösse an, um den Bereich auszuwählen, den Sie behalten möchten.",
        firstname: "Vorname",
        lastname: "Nachname",
        email: "E-Mail",
        mobile: "Mobile",
        passwordRefresh: "Passwort aktualisieren",
        passwordInfo:
            "Stellen Sie sicher, dass Ihr Konto ein langes, zufälliges Passwort verwendet, um sicher zu sein.",
        passwordCurrent: "Aktuelles Passwort",
        passwordNew: "Neues Passwort",
        passwordConfirm: "Passwort bestätigen",
        twoFactorAuth: "Zwei-Faktor-Authentifizierung",
        twoFactorAuthInfo:
            "Erhöhen Sie die Sicherheit Ihres Kontos mit der Zwei-Faktor-Authentifizierung.",
        twoFactorAuthDeactivated:
            "Sie haben die Zwei-Faktor-Authentifizierung nicht aktiviert.",
        twoFactorAuthInfoText:
            "Wenn die Zwei-Faktor-Authentifizierung aktiviert ist, werden Sie während der Authentifizierung zur Eingabe eines sicheren, zufälligen Tokens aufgefordert. Sie können dieses Token über die Google Authenticator-Anwendung Ihres Telefons abrufen.",
        browserSessions: "Browser-Sitzungen",
        browserSessionsInfo:
            "Verwalten und melden Sie Ihre aktiven Sitzungen auf anderen Browsern und Geräten ab.",
        browserSessionsText:
            "Falls erforderlich, können Sie sich von allen anderen Browser-Sitzungen auf allen Ihren Geräten abmelden. Einige Ihrer letzten Sitzungen sind unten aufgeführt; diese Liste ist jedoch möglicherweise nicht vollständig. Wenn Sie glauben, dass Ihr Konto kompromittiert wurde, sollten Sie auch Ihr Passwort aktualisieren.",
        browserSessionsLogOut: "Abmelden aus anderen Browser Sitzungen",
        browserSessionsEnterPw:
            "Bitte geben Sie Ihr Passwort ein, um zu bestätigen, dass sie sich von allen anderen Browsersitzungen abmelden möchten",
        deleteAccount: "Konto löschen",
        deleteAccountInfo: "Konto dauerhaft löschen",
        deleteAccountText:
            "Nach der Löschung Ihres Kontos werden alle Ressourcen und Daten dauerhaft gelöscht. Bevor Sie Ihr Konto löschen, laden Sie bitte alle Daten oder Informationen herunter, die Sie aufbewahren möchten.",
        deleteAccountConfirm:
            "Sind Sie sicher, dass Sie Ihr Konto löschen möchten? Wenn Ihr Konto gelöscht wird, werden alle Ressourcen und Daten dauerhaft gelöscht. Bitte geben Sie Ihr Passwort ein, um zu bestätigen, dass Sie Ihr Konto endgültig löschen möchten.",
        twoFactorEnableInfoText:
            "Die Zwei-Faktor-Authentifizierung ist jetzt aktiviert. Scannen Sie den folgenden QR-Code mit der Authentifizierungsanwendung Ihres Telefons.",
        twoFactorRecoveryInfoText:
            "Speichern Sie diese Wiederherstellungscodes in einem sicheren Passwort-Manager. Sie können verwendet werden, um den Zugang zu Ihrem Konto wiederherzustellen, wenn Ihr Zwei-Faktor-Authentifizierungsgerät verloren geht.",
        regenerateRecoveryCodes: "Wiederherstellungscodes neu generieren",
        showRecoveryCodes: "Wiederherstellungscodes anzeigen",
        passwordUpdated: "Password wurde aktualisiert",
        profileUpdated: "Profil wurde aktualisiert",
    },
    clients: {
        myApartments: "Meine Wohnungen",
    },
    taxRates: {
        title: "Mehrwertsteuern",
        newRate: "Neuer Steuersatz",
        deleteRate: "Steuersatz löschen",
        deleteRateInfo:
            "Mehrwertsteuersätze dürfen nur gelöscht werden, wenn sie in keiner Offerte verwendet wurden. Andernfalls führt das Löschen zu einem inkonsistenten Systemzustand. Im Zweifelsfall sollte nicht gelöscht werden.",
        importantNotice: "Wichtiger Hinweis",
        new: "Neuer Mehrwertsteuersatz",
        description: "Anlegen eines neuen Mehrwertsteuersatzes",
        name: "Bezeichnung",
        nameDesc: "Bezeichnung mit Prozentzeichen (z.B. 8.1%)",
        isDefault: "Als Standard setzen",
        standardVat: "Standard Mehrwertsteuersatz",
        value: "Wert",
        valueDesc: "Wert in Prozent (Punkt verwenden ohne Prozentzeichen!)",
        code: "Code",
        deleted: "Mehrwertsteuersatz gelöscht",
        info: "Bereits verwendete Mehrwertsteuersätze dürfen niemals bearbeitet oder gelöscht werden! Neue Mehrwertsteuersätze können nur durch Anlegen eines neuen Eintrags hinzugefügt werden. Sobald ein neuer Mehrwertsteuerstatz in Kraft tritt, kann er als Standardsteuersatz markiert werden, so dass er bei der Erstellung neuer Offerten automatisch vorausgewählt wird.",
    },
    deadlines: {
        overdue: "1 oder mehr Entscheidungen überfällig.",
        nearing: "1 oder mehr Entscheidungen fällig innerhalb von {threshold} Tagen.",
        on_track:
            "1 oder mehr Entscheidungen ausstehend, Frist ≥ {threshold} Tage entfernt.",
        no_due_date:
            "1 oder mehr Entscheidungen ausstehend, aber kein Fälligkeitsdatum gesetzt.",
    },
    errors: {
        title: {
            500: "Ein Fehler ist aufgetreten",
            503: "Seite nicht erreichbar",
            404: "Seite wurde nicht gefunden",
            403: "Diese Aktion ist nicht erlaubt",
        },
        detail: {
            500: "Whoops da ist was schief gegangen. Melde dich doch bitte bei unserem Support",
            503: "Wir führen gerade Wartungsarbeiten durch. Wir sind bald wieder für dich da.",
            404: "Die Seite die aufrufen wolltest existiert leider nicht (mehr).",
            403: "Du darfst diese Seite leider nicht aufrufen",
        },
        // N1 (Fix-Runde 1): eigener, knapper Key für Inline-Fehlerbanner in
        // Modalen — `errors.detail.500` ist der Fehlerseiten-Text inkl.
        // Support-Aufforderung, nicht für einen Toast/Banner gedacht.
        unexpected: "Etwas ist schiefgelaufen. Bitte versuche es erneut.",
    },
    chat: {
        chat: "Chat",
        buyer: "Käufer",
        buyers: "Käufer",
        consultant: "Käuferbetreuung",
        online: "Online",
        offline: "Offline",
        typeMessage: "Nachricht eingeben",
        loadMore: "Mehr laden",
        loading: "Laden...",
        noMedia: "Noch keine Medien geteilt",
        noDocs: "Noch keine Dokumente geteilt",
        noLinks: "Noch keine Links geteilt",
        media: "Medien",
        docs: "Dokumente",
        links: "Links",
        sharedContent: "Geteilte Inhalte",
        today: "Heute",
        yesterday: "Gestern",
        searchMessages: "Nachrichten suchen",
        searchPlaceholder: "Nachrichten suchen...",
        noSearchResults: "Keine Nachrichten gefunden",
        searchDescription:
            "Suchen Sie nach Nachrichten mit Schlagworten oder bestimmten Themen.",
        messageInfo: "Nachrichten-Info",
        sent: "Gesendet",
        seenBy: "Gesehen von",
        read: "Gelesen",
        seen: "Gesehen",
        notSeenYet: "Noch nicht gesehen",
        waitingParticipants: "Warten darauf, dass Teilnehmer diese Nachricht lesen.",
        searchInChat: "Im Chat suchen...",
        noBuyersAssigned: "Keine Käufer zugewiesen",
        noBuyersAssignedDesc:
            "Diesem Apartment sind derzeit keine Käufer zugewiesen. Um ein Gespräch zu beginnen, fügen Sie bitte zuerst einen Käufer zu diesem Apartment hinzu.",
        goBackToOverview: "Zurück zur Übersicht",
        dropFilesToSend: "Dateien zum Senden ablegen",
        releaseToStageFile: "Loslassen, um Datei bereitzustellen",
        // `online`/`offline` standen in diesem Block ein zweites Mal (weiter
        // oben, wertgleich) — vom neuen Duplikat-Test aufgedeckt und hier
        // entfernt; `en.js` fuehrt sie ohnehin nur einmal.
        isTyping: "schreibt...",
        typing: "schreibt...",
        searchInChatDesc: "Text finden & zwischen Treffern springen",
        searchWithDate: "Nach Datum suchen",
        searchWithDateDesc: "Zu einem bestimmten Tag springen",
        enableChat: "Chat aktivieren",
        disableChat: "Chat deaktivieren",
        toggleChatForBuyers: "Chat für Käufer ein-/ausschalten",
        sendVoice: "Sprachnachricht senden",
        send: "Senden",
        chatDisabled: "Chat ist für diese Wohnung derzeit deaktiviert",
        enableChatToTalk:
            "Aktivieren Sie den Chat im Optionsmenü, um die Kommunikation mit Käufern zu ermöglichen",
        unmuteNotifications: "Benachrichtigungen einschalten",
        muteNotifications: "Benachrichtigungen stummschalten",
        toggleChatAlerts: "Chat-Benachrichtigungen ein-/ausschalten",
        markAsUnread: "Als ungelesen markieren",
        markAsUnreadSubtitle: "Ungelesene Markierung für alle Berater setzen",
        seeMore: "Mehr sehen",
        seeLess: "Weniger sehen",
        edited: "bearbeitet",
        jumpToDate: "Zum Datum springen",
        cancel: "Abbrechen",
        retake: "Erneut versuchen",
        confirmUpload: "Bestätigen & Hochladen",
        chatUpdated: "Chat aktualisiert",
        chatDisabledMsg: "Chat wurde für Käufer deaktiviert",
        chatEnabledMsg: "Chat wurde für Käufer aktiviert",
        document: "Dokument",
        photos: "Fotos",
        videos: "Videos",
        camera: "Kamera",
        audio: "Audio",
        reply: "Antworten",
        react: "Reaktion",
        openChat: "Chat öffnen",
        loadingMessages: "Nachrichten werden geladen...",
        noMessagesYet: "Noch keine Nachrichten. Starten Sie das Gespräch.",
        replyingTo: "Antwort an",
        editingMessage: "Nachricht bearbeiten",
        goToMessage: "Zur Nachricht",
        captureWebcam: "Aufnahme mit Ihrer Webcam",
        you: "Du",
        noPreviewAvailable: "Keine Vorschau verfügbar",
        addCaption: "Beschriftung hinzufügen...",
        editImage: "Bild bearbeiten",
        takePhoto: "Foto aufnehmen",
        tryDifferentKeywords: "Andere Suchbegriffe oder Datumsangaben versuchen.",
        sharedInProject: "Im Projekt geteilt",
    },
    crop: {
        cropYourImage: "Bild zuschneiden",
        crop: "Zuschneiden",
        cropInstructions:
            "Verschieben und skalieren Sie das Quadrat, um den gewünschten Bereich auszuwählen. Die Ausgabe behält die hohe Auflösung basierend auf Ihrer Auswahl bei",
        cancel: "Abbrechen",
        upload: "Hochladen",
    },
    buildings: {
        unassigned: "Noch nicht zugeordnet",
        expandAll: "Alle aufklappen",
        collapseAll: "Alle zuklappen",
        menu: "Menü",
        rename: "Umbenennen",
        moveUp: "Nach oben",
        moveDown: "Nach unten",
        delete: "Löschen",
        deleteTitle: "Gebäude löschen",
        apartment: "Wohnung",
        apartments: "Wohnungen",
        emptyHint: "Leer — eine Wohnung hierher ziehen oder über „Verschieben nach…“ zuordnen.",
        dragToMove: "Zum Verschieben ziehen",
        nudgeOne: "Noch 1 Wohnung ist keinem Gebäude zugeordnet — über das ⋯-Menü zuordnen oder mit dem Griff ziehen.",
        nudgeMany: "Noch {count} Wohnungen sind keinem Gebäude zugeordnet — über das ⋯-Menü zuordnen oder mit dem Griff ziehen.",
        building: "Gebäude",
        choose: "Gebäude wählen",
        levelNames: "Ebenen benennen",
        levelNamesTitle: "Ebenen dieses Projekts",
        levelNamesIntro:
            "Wie heissen die Ebenen in diesem Projekt? Diese Namen erscheinen im Anlegen-Menü und später als Spaltenüberschriften in den Exporten. Leer lassen übernimmt die Vorgabe.",
        level: "Ebene {number}",
        addNamed: "{level} hinzufügen",
        nameOf: "Name der Ebene „{level}“",
        moveTo: "Verschieben nach…",
        moveTitle: "Verschieben",
        moveIntro: "Wohin soll „{name}“ verschoben werden?",
        rootLevel: "Oberste Ebene",
        moveCurrent: "aktueller Ort",
        moveOwnSubtree: "eigene Untergruppe",
        moveTooDeep: "zu tief",
        depthReached: "Hier ist keine weitere Ebene mehr möglich — es sind höchstens {max} erlaubt.",
        deleteConfirm: "„{name}“ wirklich löschen?",
        deleteConfirmWithApartments:
            "„{name}“ wirklich löschen? Die {count} zugeordneten Wohnungen wandern zu „Noch nicht zugeordnet“.",
    },
    // Plan vorlage-auf-wohnungen (Task 10)
    templateTransfer: {
        notify: "Käufer benachrichtigen",
        switchBlocked: "Die Vorlage kann nur gewechselt werden, solange das Projekt keine Wohnungen hat. Änderungen an den Themen nehmen Sie direkt in der Projektvorlage vor und übertragen sie anschliessend auf die bestehenden Wohnungen.",
        openTransfer: "Wohnungen auswählen",
        completedCount: "Eine abgeschlossene Wohnung wird nicht angepasst. | {count} abgeschlossene Wohnungen werden nicht angepasst.",
        apartmentCount: "Eine Wohnung | {count} Wohnungen",
        noBuilding: "Ohne Gebäude",
        tag: {
            sameName: "ein gleichnamiges Thema vorhanden | {count} gleichnamige Themen vorhanden",
            individual: "eine individuell | {count} individuell",
            offer: "eine angenommene Offerte | {count} angenommene Offerten",
            progress: "eine in Bearbeitung | {count} in Bearbeitung",
            blocked: "eine gesperrt | {count} gesperrt",
            deleted: "eine bewusst gelöscht | {count} bewusst gelöscht",
        },
        decision: {
            apply: "Übertragen",
            keep: "Später",
            discard: "Nicht übertragen",
        },
        statKeep: "Später",
        statDiscard: "Wird nicht übertragen",
        askLater: "Später entscheiden",
        dismiss: "Nur für neue Wohnungen",
        onlyNewTitle: "Nur für neue Wohnungen?",
        onlyNewText: "Die bestehenden Wohnungen bleiben unverändert. Diese Änderung kann später nicht mehr auf sie übertragen werden. | Die bestehenden Wohnungen bleiben unverändert. Diese {count} Änderungen können später nicht mehr auf sie übertragen werden.",
        changesTitle: "Änderungen an der Vorlage",
        loading: "Vorschau wird geladen …",
        title: "Vorlage auf Wohnungen übertragen",
        step: "Schritt {step} von 2",
        stepSelect: "Auswahl",
        stepPreview: "Vorschau",
        stepReport: "Bericht",
        openChanges: "Eine Änderung ist noch nicht in allen bestehenden Wohnungen übernommen. | {count} Änderungen sind noch nicht in allen bestehenden Wohnungen übernommen.",
        openChangesNone: "Alle bestehenden Wohnungen entsprechen der Vorlage.",
        transfer: "Übertragen",
        askTitle: "Bestehende Wohnungen anpassen?",
        askText: "Die Vorlage ist gespeichert und gilt für alle neuen Wohnungen. Eine Änderung ist in bestehenden Wohnungen noch nicht übernommen. | Die Vorlage ist gespeichert und gilt für alle neuen Wohnungen. {count} Änderungen sind in bestehenden Wohnungen noch nicht übernommen.",
        askOnlyNew: "Nur für neue Wohnungen",
        askTransfer: "Auswählen",
        apartments: "Wohnungen",
        scopeAll: "Alle offenen ({count})",
        scopeSelection: "Auswahl",
        selected: "Eine Wohnung gewählt. | {count} Wohnungen gewählt.",
        partialHint: "Nicht alle Wohnungen erhalten alle Änderungen. Die Vorlage gilt trotzdem für alle neuen Wohnungen: Neu angelegte Wohnungen erhalten diese Änderungen ebenfalls.",
        showPreview: "Vorschau anzeigen",
        back: "Zurück",
        statApply: "Wird übertragen",
        statSkipped: "Übersprungen",
        statConfirm: "Mit Bestätigung",
        statBlocked: "Gesperrt",
        nothing: "Keine offenen Änderungen",
        completed: "Abgeschlossen, wird nicht angepasst",
        override: "trotzdem übertragen",
        warnBuyers: "Käufer sehen die Änderungen sofort.",
        warnIrreversible: "Die Übertragung kann nicht rückgängig gemacht werden.",
        warnOffers: "Bei einer Wohnung gibt es eine angenommene Offerte. Ein geändertes Budget ändert die Mehrkosten für den Käufer. | Bei {count} Wohnungen gibt es angenommene Offerten. Ein geändertes Budget ändert die Mehrkosten für den Käufer.",
        warnInProgress: "Bei einer Wohnung ist ein zu entfernendes Thema schon in Bearbeitung. | Bei {count} Wohnungen ist ein zu entfernendes Thema schon in Bearbeitung.",
        retry: "Offene Punkte erneut übertragen",
        close: "Schliessen",
        kind: {
            add: "Neues Thema",
            remove: "Thema entfernen",
            attach_set: "Auswahlliste ergänzen",
            detach_set: "Auswahlliste entfernen",
        },
        field: {
            icon: "Symbol",
            budget: "Budget",
            inclusive: "Inklusivbudget",
            disable_calculation: "Berechnung deaktiviert",
            active: "Aktiv",
            supplier_uuid: "Unternehmer",
            name: "Name",
            description: "Beschreibung",
            sets: "Auswahlliste",
        },
        // Staging-Runde 2: Satz oben je Ausnahme-Art, Angabe je Wohnung, Bericht
        all: "Alle {count}",
        why: {
            individual: {
                label: "Individuell",
                text: "Der Wert wurde in der Wohnung von Hand angepasst.",
            },
            sameName: {
                label: "Gleichnamiges Thema",
                text: "Die Wohnung hat schon ein Thema mit diesem Namen.",
            },
            offer: {
                label: "Angenommene Offerte",
                text: "Ein neues Budget ändert die Mehrkosten des Käufers.",
            },
            progress: {
                label: "In Bearbeitung",
                text: "Status, Unternehmer und Hinweis gehen beim Entfernen verloren.",
            },
            blockedData: {
                label: "Gesperrt",
                text: "Erst Bestellungsänderungen, Dokumente und Käuferwahlen entfernen.",
            },
            blockedSelection: {
                label: "Gesperrt",
                text: "Erst die Auswahl des Käufers zurücksetzen.",
            },
            translation: {
                label: "Übersetzung fehlt",
                text: "Erst den Namen in dieser Sprache übertragen.",
            },
        },
        detail: {
            ownValue: "eigener Wert {value}",
            before: "bisher {value}",
            modifications: "1 Bestellungsänderung | {count} Bestellungsänderungen",
            documents: "1 Dokument | {count} Dokumente",
            selections: "1 Käuferwahl | {count} Käuferwahlen",
        },
        summary: {
            changes: "Eine Änderung | {count} Änderungen",
            applied: "in einer Wohnung übertragen | in {count} Wohnungen übertragen",
            nothing: "Nichts übertragen",
            kept: "{count} später",
            discarded: "{count} nicht übertragen",
            completed: "1 abgeschlossene Wohnung | {count} abgeschlossene Wohnungen",
            notified: "1 Käufer benachrichtigt. | {count} Käufer benachrichtigt.",
        },
        section: {
            kept: {
                title: "Später",
                text: "Bleibt im Hinweis auf der Vorlagenseite und kann jederzeit übertragen werden.",
            },
            discarded: {
                title: "Nicht übertragen",
                text: "Die Wohnungen bleiben, wie sie sind.",
            },
            completed: {
                title: "Abgeschlossen",
                text: "Diese Wohnungen werden nicht angepasst.",
            },
        },
        empty: "leer",
        yes: "ja",
        no: "nein",
    },
};
